import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/animeData";

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: {
    bg: "hover:bg-primary-50",
    text: "group-hover:text-primary-600",
    iconBg: "bg-primary-100 text-primary-600",
  },
  accent: {
    bg: "hover:bg-accent-50",
    text: "group-hover:text-accent-600",
    iconBg: "bg-accent-100 text-accent-600",
  },
  secondary: {
    bg: "hover:bg-secondary-50",
    text: "group-hover:text-secondary-600",
    iconBg: "bg-secondary-100 text-secondary-600",
  },
};

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-site">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {t("home.categoriesTitle")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            {t("home.categoriesSubtitle")}
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 transition-all duration-300 cursor-pointer ${colors.bg}`}
                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
              >
                <div className={`w-12 h-12 rounded-full flex items-center justify-center ${colors.iconBg} transition-colors duration-300`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <div className="text-center">
                  <h3 className={`text-sm font-semibold text-foreground-800 transition-colors duration-300 font-heading ${colors.text}`}>
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{cat.count} 篇评测</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}